export default {
  currentTab: state => state.currentTab,
  group: state => state.group,
  groupDetailCk: state => state.groupDetailCk,
  groupDetailId: state => state.groupDetailId,
  groups: state => state.groups,
  groupSettings: state => state.groupSettings,
  hasSelectedAll: state =>
    state.group !== null &&
    state.parentGroup !== null &&
    state.subGroup !== null,
  hasSelectedGroup: state => state.group !== null,
  hasSelectedParentGroup: state => state.parentGroup !== null,
  hasSelectedSubgroup: state => state.subGroup !== null,
  hasSelection: state =>
    state.group !== null ||
    state.parentGroup !== null ||
    state.subGroup !== null,
  // loginSubGroups: (state) => state.loginSubGroups,
  parentGroup: state => state.parentGroup,
  parentGroups: state => state.parentGroups,
  searchId: state => state.searchId,
  searchName: state => state.searchName,
  searching: state => state.searching,
  searchResults: state => state.searchResults,
  searchSelection: state => {
    let selection = {
      parentGroupCk: '',
      groupCk: '',
      subGroupCk: ''
    };
    if (state.parentGroup) {
      selection.parentGroupCk = state.parentGroup.parentGroupCk;
    }
    if (state.group) {
      selection.groupCk = state.group.groupCk;
    }
    if (state.subGroup) {
      selection.subGroupCk = state.subGroup.subGroupCk;
    }
    return selection;
  },
  selected: state => {
    let selected = {
      parentGroupCk: '',
      parentGroupId: '',
      parentGroupName: 'All Parent Groups',
      groupCk: '',
      groupId: '',
      groupName: 'All Groups',
      subGroupCk: '',
      subGroupId: '',
      subGroupName: 'All Subgroups'
    };

    if (state.parentGroup) {
      selected.parentGroupCk = state.parentGroup.parentGroupCk;
      selected.parentGroupId = state.parentGroup.parentGroupId;
      selected.parentGroupName = state.parentGroup.parentGroupName;
    }

    if (state.group) {
      selected.groupCk = state.group.groupCk;
      selected.groupId = state.group.groupId;
      selected.groupName = state.group.groupName;
    }

    if (state.subGroup) {
      selected.subGroupCk = state.subGroup.subGroupCk;
      selected.subGroupId = state.subGroup.subGroupId;
      selected.subGroupName = state.subGroup.subGroupName;
    }

    return selected;
  },
  showSearch: state => state.showSearch,
  subGroup: state => state.subGroup,
  subGroupDetailCk: state => state.subGroupDetailCk,
  subGroups: state => {
    return state.subGroups;
  },
  tabs: state => state.tabs,
  tabsVisible: state => state.tabsVisible,
  userHasOneParent: (state, getters, rootState, rootGetters) => {
    if (!rootGetters['isInternalUser']) {
      let pagrs = new Set(
        rootGetters.subGroupAccess.map(sg => sg.parentGroupCk)
      );
      // console.log(`pagrs`, pagrs);
      return pagrs.size === 1;
    } else {
      return false;
    }
  },
  // user is only in 1 parent, which only has 1 group, which only has 1 subGroup
  userHasTripleOnes: (state, getters, rootState, rootGetters) => {
    if (!rootGetters['isInternalUser']) {
      let pagrs = new Set(
        rootGetters.subGroupAccess.map(sg => sg.parentGroupCk)
      );
      let grps = new Set(rootGetters.subGroupAccess.map(sg => sg.groupCk));
      let subgrps = new Set(
        rootGetters.subGroupAccess.map(sg => sg.subGroupCk)
      );
      return pagrs.size === 1 && grps.size === 1 && subgrps.size === 1;
    }
    return false;
  }
};
